import { faSquareXmark } from '@fortawesome/pro-solid-svg-icons';
import { useAtomValue } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';
import { Button, Icon, Text } from '@growtherapy/sprout-ui';

import { isScreenSharingAtom } from '../../video-sdk';
import useScreenShareCallbacks from './useScreenShareCallbacks';

export function StopScreenShareButton({ onClick }: { onClick: () => void }) {
  const t = useTranslate();
  return (
    <Text className='flex z-10 w-full text-neutral-100 justify-center items-center pb-2' variant='sm'>
      <span className='mr-2'>{t('telehealth-core:screenShare.youAreSharingScreen')}</span>
      <Button onClick={onClick} use='destructive' size='sm' className='flex items-center gap-2'>
        <Icon aria-hidden icon={faSquareXmark} />
        <span aria-hidden>{t('telehealth-core:screenShare.stopSharing')}</span>
        <span className='sr-only'>{t('telehealth-core:screenShare.stopSharingScreen')}</span>
      </Button>
    </Text>
  );
}

export function StopScreenShareButtonWrapper() {
  const isSharing = useAtomValue(isScreenSharingAtom);
  const { stopScreenShare } = useScreenShareCallbacks();

  if (!isSharing) return null;

  return <StopScreenShareButton onClick={stopScreenShare} />;
}
